
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { DatePicker } from '@/components';
import { EntityMetadata, MetadataType } from '@/models';

@Component({
    components:{
        DatePicker
    }
})

export default class ItemListEntityMetadata extends Vue {
    @Prop() private entityMetadata!: EntityMetadata;
    private metadataType = MetadataType;
}
